export const HttpMixins = {
    data() {
        const token = localStorage.getItem('accessToken');
        const headers = {
            'Content-Type': 'application/json',
            'X-Client-Platform': 'web'
        };
        if (token) {
            headers['Authorization'] = token;
        }

        const headersWithoutJson = { ...headers };
        delete headersWithoutJson['Content-Type'];

        return {
            headers,
            headersWithoutJson
        };
    },

    methods: {
        async catchError(error) {
            const response = error.response;

            if (!response) {
                // this.$message.error("网络异常，无法连接服务器");
                return;
            }

            const { status, data, config } = response;
            const code = data?.code;
            const message = data?.msg || "请求出错";
            switch (status) {
                case 401:
                    if (code === 10001 || code === 10002) {
                        // 避免死循环刷新
                        if (!config._retry) {
                            config._retry = true;

                            const success = await this.refreshAccessToken();
                            if (success) {
                                // 更新 Authorization header 并重试请求
                                config.headers['Authorization'] = localStorage.getItem('accessToken');
                                try {
                                    return await this.$axios(config);
                                } catch (e) {
                                    this.$message.error("请求重试失败，请重试操作");
                                    return;
                                }
                            }
                        }

                        this.$message.warning("登录状态已过期，请重新登录");
                        this.handleLogout();
                    } else if (code === 10006) {
                        this.$message.warning("登录状态已失效，请重新登录");
                        this.handleLogout();
                    } else if (code === 10007) {
                        this.$message.warning("用户名或密码错误");
                    } else {
                        this.$message.warning(message);
                    }
                    break;

                case 403:
                    if (code === 10008) {
                        this.$message.error("用户已被禁用，请联系管理员");
                    } else {
                        this.$message.error("无访问权限");
                    }
                    this.handleLogout();
                    break;

                case 422:
                    if (code === 10003) {
                        this.$message.error("Token 格式不合法");
                    } else {
                        this.$message.error(message);
                    }
                    this.handleLogout();
                    break;

                case 415:
                    if (code === 10004) {
                        this.$message.error("不支持的 Token 类型");
                    } else {
                        this.$message.error(message);
                    }
                    this.handleLogout();
                    break;

                case 400:
                    if (code === 10005) {
                        this.$message.error("请求参数非法或缺失");
                    } else {
                        this.$message.error(message);
                    }
                    this.handleLogout();
                    break;

                case 500:
                    this.$message.error("服务器内部错误，请稍后再试");
                    break;

                default:
                    this.$message.error(message);
                    break;
            }
        },

        handleLogout() {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("username");
            localStorage.removeItem("permissionList");
            this.$router.push("/login");
        },

        async refreshAccessToken() {
            try {
                const res = await this.$axios.post(
                    `${window._CONFIG['authURL']}/refresh`,
                    null,
                    { withCredentials: true }
                );

                const accessToken = res?.data?.data?.accessToken;
                if (accessToken) {
                    const tokenStr = accessToken.startsWith('Bearer ') ? accessToken : `Bearer ${accessToken}`;
                    localStorage.setItem('accessToken', tokenStr);
                    return true;
                }

                return false;
            } catch (e) {
                console.error("刷新 accessToken 失败", e);
                return false;
            }
        }
    }
};
